(function () {
  var SELECTOR = '[data-carousel-progress]';
  var instances = [];

  function CarouselProgress(bar) {
    this.bar = bar;
    this.thumb = bar.querySelector('[data-carousel-progress-thumb]');
    this.section = bar.closest('[data-section-id]');
    this.slider = this.section
      ? this.section.querySelector('[data-slider-id="' + bar.getAttribute('data-carousel-progress') + '"]')
      : null;
    if (!this.slider || !this.thumb) return;

    this.pointerId = null;
    this.raf = null;

    this.onPointerDown = this.pointerDown.bind(this);
    this.onPointerMove = this.pointerMove.bind(this);
    this.onPointerUp = this.pointerUp.bind(this);
    this.onKeyDown = this.keyDown.bind(this);
    this.onUpdate = this.schedule.bind(this);

    this.bar.addEventListener('pointerdown', this.onPointerDown);
    this.bar.addEventListener('keydown', this.onKeyDown);
    this.slider.addEventListener('scroll', this.onUpdate, { passive: true });
    window.addEventListener('resize', this.onUpdate);

    this.observer = new MutationObserver(this.onUpdate);
    this.observer.observe(this.slider, { attributes: true, attributeFilter: ['class'] });
    this.watchTrack();

    this.schedule();
    this.ready = true;
  }

  CarouselProgress.prototype.watchTrack = function () {
    var track = this.slider.querySelector('.flickity-slider');
    if (track === this.track) return;
    if (this.trackObserver) this.trackObserver.disconnect();
    this.track = track;
    if (!track) return;
    this.trackObserver = new MutationObserver(this.onUpdate);
    this.trackObserver.observe(track, { attributes: true, attributeFilter: ['style'] });
  };

  CarouselProgress.prototype.isFlickity = function () {
    return this.slider.classList.contains('flickity-enabled');
  };

  CarouselProgress.prototype.cells = function () {
    return Array.prototype.slice.call(this.slider.querySelectorAll('[data-slide]'));
  };

  CarouselProgress.prototype.trackOffset = function () {
    var value = getComputedStyle(this.track).transform;
    if (!value || value === 'none') return 0;
    try {
      return -new DOMMatrixReadOnly(value).m41;
    } catch (e) {
      return 0;
    }
  };

  CarouselProgress.prototype.metrics = function () {
    var cells = this.cells();
    if (!cells.length) return null;

    if (this.isFlickity()) {
      this.watchTrack();
      var viewport = this.slider.querySelector('.flickity-viewport');
      if (!viewport || !this.track) return null;

      var visible = viewport.getBoundingClientRect().width;
      var first = cells[0].getBoundingClientRect();
      var last = cells[cells.length - 1].getBoundingClientRect();
      var total = last.right - first.left;
      var max = total - visible;
      if (max <= 1) return null;

      return { position: Math.min(Math.max(this.trackOffset(), 0), max), max: max, visible: visible, total: total };
    }

    var scrollMax = this.slider.scrollWidth - this.slider.clientWidth;
    if (scrollMax <= 1) return null;
    return {
      position: Math.min(Math.max(this.slider.scrollLeft, 0), scrollMax),
      max: scrollMax,
      visible: this.slider.clientWidth,
      total: this.slider.scrollWidth,
    };
  };

  CarouselProgress.prototype.schedule = function () {
    if (this.raf) return;
    this.raf = requestAnimationFrame(
      function () {
        this.raf = null;
        this.render();
      }.bind(this)
    );
  };

  CarouselProgress.prototype.render = function () {
    var m = this.metrics();
    if (!m) {
      this.bar.classList.remove('is-active');
      return;
    }

    this.bar.classList.add('is-active');

    var size = Math.min(Math.max(m.visible / m.total, 0.12), 1);
    var fraction = m.position / m.max;
    var width = this.bar.clientWidth;

    this.thumb.style.setProperty('--carousel-progress-size', size.toFixed(4));
    this.thumb.style.setProperty('--carousel-progress-offset', (fraction * width * (1 - size)).toFixed(2) + 'px');
    this.bar.setAttribute('aria-valuenow', Math.round(fraction * 100));
  };

  CarouselProgress.prototype.fractionFromEvent = function (event) {
    var rect = this.bar.getBoundingClientRect();
    if (!rect.width) return 0;
    return Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
  };

  CarouselProgress.prototype.seek = function (fraction, smooth) {
    if (this.isFlickity()) {
      this.seekFlickity(fraction);
      return;
    }

    var scrollMax = this.slider.scrollWidth - this.slider.clientWidth;
    this.slider.scrollTo({ left: fraction * scrollMax, behavior: smooth ? 'smooth' : 'auto' });
  };

  CarouselProgress.prototype.seekFlickity = function (fraction) {
    var cells = this.cells();
    var selected = cells.filter(function (cell) {
      return cell.classList.contains('is-selected');
    });
    if (!selected.length) return;

    var perGroup = selected.length;
    var groups = Math.ceil(cells.length / perGroup);
    if (groups < 2) return;

    var current = Math.floor(cells.indexOf(selected[0]) / perGroup);
    var target = Math.min(Math.max(Math.round(fraction * (groups - 1)), 0), groups - 1);
    var steps = target - current;
    if (!steps) return;

    this.click(steps > 0 ? 'next' : 'previous', Math.abs(steps));
  };

  CarouselProgress.prototype.click = function (direction, times) {
    var button = this.section.querySelector('.flickity-prev-next-button.' + direction);
    if (!button) return;
    for (var i = 0; i < times; i++) {
      if (button.disabled) break;
      button.click();
    }
  };

  CarouselProgress.prototype.step = function (direction) {
    if (this.isFlickity()) {
      this.click(direction > 0 ? 'next' : 'previous', 1);
      return;
    }
    this.slider.scrollBy({ left: direction * this.slider.clientWidth, behavior: 'smooth' });
  };

  CarouselProgress.prototype.pointerDown = function (event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    event.preventDefault();
    this.pointerId = event.pointerId;
    this.bar.classList.add('is-dragging');
    this.bar.focus();
    if (this.bar.setPointerCapture) this.bar.setPointerCapture(event.pointerId);
    document.addEventListener('pointermove', this.onPointerMove);
    document.addEventListener('pointerup', this.onPointerUp);
    document.addEventListener('pointercancel', this.onPointerUp);
    this.seek(this.fractionFromEvent(event), true);
  };

  CarouselProgress.prototype.pointerMove = function (event) {
    if (event.pointerId !== this.pointerId) return;
    this.seek(this.fractionFromEvent(event), false);
  };

  CarouselProgress.prototype.pointerUp = function (event) {
    if (event.pointerId !== this.pointerId) return;
    this.pointerId = null;
    this.bar.classList.remove('is-dragging');
    document.removeEventListener('pointermove', this.onPointerMove);
    document.removeEventListener('pointerup', this.onPointerUp);
    document.removeEventListener('pointercancel', this.onPointerUp);
  };

  CarouselProgress.prototype.keyDown = function (event) {
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.step(1);
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.step(-1);
    } else if (event.key === 'Home') {
      event.preventDefault();
      this.seek(0, true);
    } else if (event.key === 'End') {
      event.preventDefault();
      this.seek(1, true);
    }
  };

  CarouselProgress.prototype.destroy = function () {
    this.bar.removeEventListener('pointerdown', this.onPointerDown);
    this.bar.removeEventListener('keydown', this.onKeyDown);
    this.slider.removeEventListener('scroll', this.onUpdate);
    window.removeEventListener('resize', this.onUpdate);
    if (this.observer) this.observer.disconnect();
    if (this.trackObserver) this.trackObserver.disconnect();
    if (this.raf) cancelAnimationFrame(this.raf);
  };

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (bar) {
      if (bar.dataset.carouselProgressReady) return;
      var instance = new CarouselProgress(bar);
      if (!instance.ready) return;
      bar.dataset.carouselProgressReady = 'true';
      instances.push(instance);
    });
  }

  function refresh() {
    instances.forEach(function (instance) {
      instance.schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  window.addEventListener('load', function () {
    init();
    refresh();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    refresh();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    instances = instances.filter(function (instance) {
      if (!event.target.contains(instance.bar)) return true;
      instance.destroy();
      return false;
    });
  });
})();
